// Module
var code = "<script id=\"wcc-components-attachment-title-editor\" type=\"text/template\">\r\n    <span class=\"glyphicons glyphicons-pencil text-light-black\"></span>\r\n    <input class=\"input-borderless text-sm\" type=\"text\" maxlength=\"100\" data-bind=\"textInput: title\">\r\n</script>";
// Exports
module.exports = code;